// extracted by mini-css-extract-plugin
export var enter = "SearchAutocomplete-module--enter--OSNLl";
export var enterActive = "SearchAutocomplete-module--enterActive---OIkC";
export var enterDone = "SearchAutocomplete-module--enterDone--fKZKo";
export var exit = "SearchAutocomplete-module--exit--uGZe1";
export var exitActive = "SearchAutocomplete-module--exitActive--AcOiK";